"use strict";

exports.__esModule = true;
exports.UiPreferencesDialog = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Heading = require("../Core/Heading");
var _Translator = require("../Core/Translator");
var _UiPreferencesContext = require("./UiPreferencesContext");
var _resolveUiDesign = require("../Theme/UiDesign/resolveUiDesign");
var _uiPreferences = require("./uiPreferences");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// The screens a user can switch, in the order the sidebar lists them.
var SCREENS = [{
  id: "dashboard",
  messageId: "UiPreferences.screen.dashboard",
  label: "Dashboards"
}, {
  id: "reports",
  messageId: "UiPreferences.screen.reports",
  label: "Reports"
}, {
  id: "operator-panel",
  messageId: "UiPreferences.screen.operatorPanel",
  label: "Operator panels"
}, {
  id: "knowledge-base",
  messageId: "UiPreferences.screen.knowledgeBase",
  label: "Knowledge base"
}, {
  id: "device-data",
  messageId: "UiPreferences.screen.deviceData",
  label: "Device data"
}, {
  id: "maintenance-manager",
  messageId: "UiPreferences.screen.maintenanceManager",
  label: "Maintenance manager"
}];
var Hint = _styledComponents["default"].div.withConfig({
  displayName: "UiPreferencesDialog__Hint",
  componentId: "sc-1fwd2x-0"
})(["font-size:12px;color:", ";margin:-6px 0 14px 38px;"], function (props) {
  return props.theme.mutedColor;
});
var Section = _styledComponents["default"].div.withConfig({
  displayName: "UiPreferencesDialog__Section",
  componentId: "sc-1fwd2x-1"
})(["font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:0.04em;color:", ";margin:18px 0 8px;"], function (props) {
  return props.theme.mutedColor;
});
var Note = _styledComponents["default"].p.withConfig({
  displayName: "UiPreferencesDialog__Note",
  componentId: "sc-1fwd2x-2"
})(["font-size:12px;color:", ";margin:16px 0 0;"], function (props) {
  return props.theme.mutedColor;
});
var Build = _styledComponents["default"].div.withConfig({
  displayName: "UiPreferencesDialog__Build",
  componentId: "sc-1fwd2x-3"
})(["margin-top:14px;font-size:11px;color:", ";font-family:", ";"], function (props) {
  return props.theme.mutedColor;
}, function (props) {
  return props.theme.ChartFontFamilyMono || "monospace";
});

// The bundle this page runs: the main script's file name carries the build
// hash, so "is this the new build?" has a one-glance answer.
function currentBuild() {
  if (typeof document === "undefined") {
    return "";
  }
  var script = Array.from(document.scripts).find(function (node) {
    return node.src && /\/main\.[a-z0-9]+\.js/.test(node.src);
  });
  return script ? script.src.split("/").pop() : "";
}
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "UiPreferencesDialog__Footer",
  componentId: "sc-1fwd2x-4"
})(["display:flex;align-items:center;margin-top:16px;.spacer{flex:1;}button + button{margin-left:5px;}"]);
var onOff = function onOff(value) {
  return value ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.on",
    defaultMessage: "on"
  }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.off",
    defaultMessage: "off"
  });
};
var same = function same(a, b) {
  return JSON.stringify((0, _uiPreferences.normalizeUiPreferences)(a)) === JSON.stringify((0, _uiPreferences.normalizeUiPreferences)(b));
};

// Reloading re-runs the flag resolution for every provider and clears any
// state a screen built under the other look. A ?ui= pin in the URL would
// pin the browser again on reload, so it goes first.
var reloadPage = function reloadPage() {
  (0, _resolveUiDesign.removeUiOverrideFromUrl)();
  window.location.reload();
};

/**
 * Lets the signed-in user choose the modern or legacy interface, overall and
 * per screen, over what the environment's flags say. The dialog edits a
 * draft: closing it with changes saves them (browser, and the service when
 * sync is on) and reloads the page so the whole UI picks them up; "Discard"
 * closes without saving.
 */
var UiPreferencesDialog = exports.UiPreferencesDialog = function UiPreferencesDialog(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$reload = _ref.reload,
    reload = _ref$reload === void 0 ? reloadPage : _ref$reload;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_UiPreferencesContext.UiPreferencesContext),
    preferences = _useContext2.preferences,
    environment = _useContext2.environment,
    save = _useContext2.save,
    syncEnabled = _useContext2.syncEnabled,
    loading = _useContext2.loading;
  var _useState = (0, _react.useState)(preferences),
    draft = _useState[0],
    setDraft = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    saving = _useState2[0],
    setSaving = _useState2[1];

  // Start from the saved record each time the dialog opens (and once a
  // pending load from the service has landed).
  (0, _react.useEffect)(function () {
    if (isOpen && !loading) {
      setDraft(preferences);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, loading]);
  var env = environment || {
    modern: false,
    screens: {}
  };
  var modern = draft.modern === null ? env.modern : Boolean(draft.modern);
  var screenValue = function screenValue(id) {
    return draft.screens[id] === undefined ? Boolean(env.screens[id]) : draft.screens[id];
  };
  var changed = !same(draft, preferences);
  var build = currentBuild();
  var edit = function edit(patch) {
    return setDraft(function (before) {
      return (0, _uiPreferences.normalizeUiPreferences)(Object.assign({}, before, patch, {
        screens: Object.assign({}, before.screens, patch && patch.screens || {})
      }));
    });
  };
  var applyAndClose = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(!changed || saving)) {
            _context.n = 1;
            break;
          }
          onClose();
          return _context.a(2);
        case 1:
          setSaving(true);
          _context.p = 2;
          _context.n = 3;
          return save(draft);
        case 3:
          _context.p = 3;
          setSaving(false);
          return _context.f(3);
        case 4:
          onClose();
          reload();
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[2,, 3, 4]]);
  })), [changed, saving, save, draft, onClose, reload]);
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    className: theme.bodyClassName,
    isOpen: isOpen,
    onClose: applyAndClose,
    canOutsideClickClose: !changed,
    style: {
      width: "460px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_HEADER
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.STYLE,
    size: 24
  }), /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: 5
  }, translate("UiPreferences.title", "Interface"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY,
    "data-testid": "ui-preferences-dialog"
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    large: true,
    checked: modern,
    disabled: loading || saving,
    "data-testid": "UiPreferences.modern",
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UiPreferences.modern",
      defaultMessage: "Use the modern interface"
    }),
    onChange: function onChange(event) {
      return edit({
        modern: event.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(Hint, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.environmentDefault",
    defaultMessage: "Environment default: {value}",
    values: {
      value: onOff(env.modern)
    }
  }), draft.modern !== null && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " · ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.yourChoice",
    defaultMessage: "your choice"
  }))), /*#__PURE__*/_react["default"].createElement(Section, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.screens",
    defaultMessage: "Screens"
  })), SCREENS.map(function (screen) {
    return /*#__PURE__*/_react["default"].createElement(_core.Switch, {
      key: screen.id,
      checked: screenValue(screen.id),
      disabled: !modern || loading || saving,
      "data-testid": "UiPreferences.screen." + screen.id,
      label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: screen.messageId,
        defaultMessage: screen.label
      }), draft.screens[screen.id] !== undefined && /*#__PURE__*/_react["default"].createElement("span", {
        className: _core.Classes.TEXT_MUTED
      }, " · ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "UiPreferences.yourChoice",
        defaultMessage: "your choice"
      }))),
      onChange: function onChange(event) {
        var _screens;
        return edit({
          screens: (_screens = {}, _screens[screen.id] = event.target.checked, _screens)
        });
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(Note, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.note.reload",
    defaultMessage: "Changes take effect when the dialog closes; the page reloads."
  }), " ", syncEnabled ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.note.synced",
    defaultMessage: "They are saved to your account."
  }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UiPreferences.note.local",
    defaultMessage: "They are kept in this browser."
  })), build && /*#__PURE__*/_react["default"].createElement(Build, {
    "data-testid": "UiPreferences.build"
  }, translate("UiPreferences.build", "Build"), " ", build), /*#__PURE__*/_react["default"].createElement(Footer, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    disabled: (0, _uiPreferences.isDefaultUiPreferences)(draft) || loading || saving,
    "data-testid": "UiPreferences.reset",
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UiPreferences.Button.Reset",
      defaultMessage: "Use environment defaults"
    }),
    onClick: function onClick() {
      return setDraft((0, _uiPreferences.normalizeUiPreferences)(_uiPreferences.EMPTY_UI_PREFERENCES));
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "spacer"
  }), changed && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    disabled: saving,
    "data-testid": "UiPreferences.discard",
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UiPreferences.Button.Discard",
      defaultMessage: "Discard"
    }),
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    intent: changed ? _core.Intent.PRIMARY : _core.Intent.NONE,
    loading: saving,
    "data-testid": "UiPreferences.apply",
    text: changed ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UiPreferences.Button.Apply",
      defaultMessage: "Apply and reload"
    }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "UiPreferences.Button.Close",
      defaultMessage: "Close"
    }),
    onClick: applyAndClose
  }))));
};